import React from "react";
import AnimatedLogo from "./AnimatedLogo";

const FormContainer = ({ title, children }) => (
  <div className="tc f--3">
    <AnimatedLogo />
    <p className="t-mt2 t-pb1 t-pt3 a-font-size-2">{title}</p>
    {children}
  </div>
);

FormContainer.defaultProps = {
  title: "Use your POPComics login"
};

export default FormContainer;
